export const CRUD_ACTIONS = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE'
};

export const FUZZY_SEARCH_DISTANCE = 2;



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/crud-actions.constants.ts